import {
  UPDATE_DEMO_MENU,
  UPDATE_DEMO_PREVIEW_PARAMS,
  UPDATE_DEMO_CARD_DETAILS
} from 'redux/constants/demo';

export const updateDemoData = (data: Record<string, any>) => ({
  type: UPDATE_DEMO_PREVIEW_PARAMS,
  payload: { data }
});

export const updateDemoMenu = (data: Record<string, any>) => ({
  type: UPDATE_DEMO_MENU,
  payload: { data }
});

export const updateDemoCardDetails = (data: Record<string, any>) => ({
  type: UPDATE_DEMO_CARD_DETAILS,
  payload: { data }
});
